import React from 'react'
import { connect } from 'react-redux'
import { Chart } from 'react-google-charts'
import { formatarReal } from '../../util/numberUtil'
import capitalizarTodasPrimeirasLetras from '../../util/capitalizarTodasPrimeirasLetras'

export class GraficoPorTipoTarifa extends React.Component {

    tooltip(item, pct) {
        return '<div class="google-visualization-tooltip-item">' +
            '<strong style="font-size:16px">' + capitalizarTodasPrimeirasLetras(item.nome) + '</strong><br/>' +
            '<span style="font-size:16px"> (Representa=): <strong>' + pct + '%</strong></span><br/>' +
            '<span style="font-size:16px"> (Q.Aprov=): <strong>' + (item.quantidadeVendas || 0) + '</strong></span><br/>' +
            '<span style="font-size:16px"> (Q.Canc=): <strong>' + (item.quantidadeCancelamentos || 0) + '</strong></span><br/>' +
            '<span style="font-size:16px"> (T.Faturado=): <strong>' + formatarReal((item.valorTotalVendas || 0).toString()) + '</strong></span><br/>' +
            '<span style="font-size:16px"> (V.Cancelado=): <strong>' + formatarReal((item.valorTotalCancelamentos || 0).toString()) + '</strong></span><br/>' +
            '<span style="font-size:16px"> (F.Liquid R$=): <strong>' + formatarReal((item.valorTotalVendasLiquido || 0).toString()) + '</strong></span><br/>' +
            '<span style="font-size:16px"> (L.Comissão=): <strong>' + formatarReal((item.valorTotalComissao || 0).toString()) + '</strong></span>' +
            '</div>'
    }

    executarDownload(arquivo) {
        const a = window.document.createElement('a')
        a.href = window.URL.createObjectURL(new Blob(['﻿', arquivo], { type: 'text/csv;' }))
        a.download = 'VexBi - Tipo de Tarifa.csv'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
    }

    exportar() {
        const dados = this.props.vexadoBI.totalFaturamentoPorTipoTarifa
        let arquivo = 'Tipo Tarifa;Q.Aprov;T.Faturado;L.Comissão\n'
        arquivo += dados.map(it =>
            `${it.nome};${it.quantidadeVendas || 0};` +
            `"${(it.valorTotalVendas || 0).toString().replace('.', ',')}";` +
            `"${(it.valorTotalComissao || 0).toString().replace('.', ',')}"`
        ).join('\n')
        this.executarDownload(arquivo)
    }

    render() {
        const dados = this.props.vexadoBI.totalFaturamentoPorTipoTarifa || []
        if (!dados.length) return <div style={{ padding: 20, textAlign: 'center', color: '#999' }}>Sem dados para o período selecionado</div>

        const totalGeral = dados.reduce((s, it) => s + Number(it.valorTotalVendas || 0), 0)
        const rows = [['Tarifa', 'Valor', { role: 'tooltip', type: 'string', p: { html: true } }]]
        dados.forEach(it => {
            const pct = totalGeral > 0 ? ((Number(it.valorTotalVendas || 0) / totalGeral) * 100).toFixed(2) : '0.00'
            rows.push([capitalizarTodasPrimeirasLetras(it.nome), Number(it.valorTotalVendas || 0), this.tooltip(it, pct)])
        })

        return <React.Fragment>
            <Chart
                chartType="PieChart"
                data={rows}
                options={{
                    title: 'Faturamento por Tipo de Tarifa',
                    tooltip: { trigger: 'selection', isHtml: true },
                }}
                width="100%"
                height={this.props.full ? '800px' : '400px'}
                chartEvents={[{
                    eventName: 'ready',
                    callback: ({ chartWrapper, google }) => {
                        const chart = chartWrapper.getChart()
                        google.visualization.events.addListener(chart, 'onmouseover', e => chart.setSelection([{ row: e.row }]))
                        google.visualization.events.addListener(chart, 'onmouseout', () => chart.setSelection([]))
                    }
                }]}
            />
            {!this.props.full && <button className="input-group-text bg-white btn-campo-busca float-right" onClick={() => this.props.expandir('tipoTarifa')}>Expandir</button>}
            {!this.props.full && <button className="input-group-text btn-laranja btn-campo-busca float-right exportar" onClick={() => this.exportar()}>Exportar Lista</button>}
        </React.Fragment>
    }
}

export function mapStateToProps(state) { return { vexadoBI: state.vexadoBI } }
export default connect(mapStateToProps, {})(GraficoPorTipoTarifa)
